import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, PhoneIcon, MailIcon, ClockIcon, CheckCircleIcon } from 'lucide-react';
import Button from '../components/ui/Button';
const Contact = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="pt-20" data-id="element-333">
      {/* Hero Section */}
      <section className="bg-neutral-light py-20" data-id="element-334">
        <div className="container mx-auto px-4 md:px-6" data-id="element-335">
          <div className="max-w-3xl mx-auto text-center" data-id="element-336">
            <motion.h1 initial={{
            opacity: 0,
            y: -20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5
          }} className="text-4xl md:text-5xl font-display font-bold mb-6" data-id="element-337">
              Contact <span className="text-toronto-blue" data-id="element-338">Us</span>
            </motion.h1>
            <motion.p initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 0.2,
            duration: 0.5
          }} className="text-xl text-neutral-dark/80" data-id="element-339">
              Ready to gain powerful insights? Our team is here to help you with
              your research needs.
            </motion.p>
          </div>
        </div>
      </section>
      {/* Contact Form and Info */}
      <section className="py-16 bg-white" data-id="element-340">
        <div className="container mx-auto px-4 md:px-6" data-id="element-341">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-342">
            {/* Contact Information */}
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} data-id="element-343">
              <h2 className="text-3xl font-display font-bold mb-6" data-id="element-344">
                Get in Touch
              </h2>
              <p className="text-lg text-neutral-dark/80 mb-8" data-id="element-345">
                Whether you have a specific research question or want to discuss
                how we can help your organization, we're here to assist you.
              </p>
              <div className="space-y-6 mb-8" data-id="element-346">
                <div className="flex items-start" data-id="element-347">
                  <div className="bg-toronto-blue/10 text-toronto-blue p-3 rounded-full mr-4" data-id="element-348">
                    <MapPinIcon size={20} data-id="element-349" />
                  </div>
                  <div data-id="element-350">
                    <h3 className="font-semibold mb-1" data-id="element-351">Visit Us</h3>
                    <p className="text-neutral-dark/80" data-id="element-352">
                      123 Research Avenue
                      <br data-id="element-353" />
                      Toronto, ON M5V 2K4
                      <br data-id="element-354" />
                      Canada
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-355">
                  <div className="bg-toronto-blue/10 text-toronto-blue p-3 rounded-full mr-4" data-id="element-356">
                    <PhoneIcon size={20} data-id="element-357" />
                  </div>
                  <div data-id="element-358">
                    <h3 className="font-semibold mb-1" data-id="element-359">Call Us</h3>
                    <p className="text-neutral-dark/80" data-id="element-360">
                      +1 (416) 555-1234
                      <br data-id="element-361" />
                      +1 (416) 555-5678
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-362">
                  <div className="bg-toronto-blue/10 text-toronto-blue p-3 rounded-full mr-4" data-id="element-363">
                    <MailIcon size={20} data-id="element-364" />
                  </div>
                  <div data-id="element-365">
                    <h3 className="font-semibold mb-1" data-id="element-366">Email Us</h3>
                    <p className="text-neutral-dark/80" data-id="element-367">
                      info@marketresearchtoronto.com
                      <br data-id="element-368" />
                      careers@marketresearchtoronto.com
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-369">
                  <div className="bg-toronto-blue/10 text-toronto-blue p-3 rounded-full mr-4" data-id="element-370">
                    <ClockIcon size={20} data-id="element-371" />
                  </div>
                  <div data-id="element-372">
                    <h3 className="font-semibold mb-1" data-id="element-373">Office Hours</h3>
                    <p className="text-neutral-dark/80" data-id="element-374">
                      Monday - Friday: 9:00 AM - 5:00 PM
                      <br data-id="element-375" />
                      Saturday - Sunday: Closed
                    </p>
                  </div>
                </div>
              </div>
              {/* Google Map Placeholder */}
              <div className="bg-neutral-light h-64 rounded-lg shadow-md flex items-center justify-center" data-id="element-376">
                <div className="text-center" data-id="element-377">
                  <p className="text-neutral-dark/70 mb-2" data-id="element-378">
                    Google Map would be displayed here
                  </p>
                  <p className="text-sm text-neutral-dark/50" data-id="element-379">
                    123 Research Avenue, Toronto
                  </p>
                </div>
              </div>
            </motion.div>
            {/* Contact Form */}
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} data-id="element-380">
              <div className="bg-neutral-light/50 p-8 rounded-lg shadow-md" data-id="element-381">
                <h2 className="text-2xl font-semibold mb-6" data-id="element-382">
                  Send Us a Message
                </h2>
                <form data-id="element-383">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-384">
                    <div data-id="element-385">
                      <label htmlFor="firstName" className="block text-sm font-medium mb-2" data-id="element-386">
                        First Name*
                      </label>
                      <input type="text" id="firstName" className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-toronto-blue/30" required data-id="element-387" />
                    </div>
                    <div data-id="element-388">
                      <label htmlFor="lastName" className="block text-sm font-medium mb-2" data-id="element-389">
                        Last Name*
                      </label>
                      <input type="text" id="lastName" className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-toronto-blue/30" required data-id="element-390" />
                    </div>
                  </div>
                  <div className="mb-6" data-id="element-391">
                    <label htmlFor="email" className="block text-sm font-medium mb-2" data-id="element-392">
                      Email Address*
                    </label>
                    <input type="email" id="email" className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-toronto-blue/30" required data-id="element-393" />
                  </div>
                  <div className="mb-6" data-id="element-394">
                    <label htmlFor="phone" className="block text-sm font-medium mb-2" data-id="element-395">
                      Phone Number
                    </label>
                    <input type="tel" id="phone" className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-toronto-blue/30" data-id="element-396" />
                  </div>
                  <div className="mb-6" data-id="element-397">
                    <label htmlFor="organization" className="block text-sm font-medium mb-2" data-id="element-398">
                      Organization
                    </label>
                    <input type="text" id="organization" className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-toronto-blue/30" data-id="element-399" />
                  </div>
                  <div className="mb-6" data-id="element-400">
                    <label htmlFor="inquiry" className="block text-sm font-medium mb-2" data-id="element-401">
                      Inquiry Type*
                    </label>
                    <select id="inquiry" className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-toronto-blue/30 bg-white" required data-id="element-402">
                      <option value="" data-id="element-403">Select an option</option>
                      <option value="research" data-id="element-404">Research Project</option>
                      <option value="consultation" data-id="element-405">Consultation</option>
                      <option value="partnership" data-id="element-406">
                        Partnership Opportunity
                      </option>
                      <option value="careers" data-id="element-407">Careers</option>
                      <option value="other" data-id="element-408">Other</option>
                    </select>
                  </div>
                  <div className="mb-6" data-id="element-409">
                    <label htmlFor="message" className="block text-sm font-medium mb-2" data-id="element-410">
                      Message*
                    </label>
                    <textarea id="message" rows={5} className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-toronto-blue/30" required data-id="element-411"></textarea>
                  </div>
                  <div className="mb-6" data-id="element-412">
                    <label className="flex items-start" data-id="element-413">
                      <input type="checkbox" className="mt-1 mr-2" data-id="element-414" />
                      <span className="text-sm text-neutral-dark/80" data-id="element-415">
                        I agree to the processing of my personal data according
                        to Market Research Toronto's Privacy Policy.
                      </span>
                    </label>
                  </div>
                  <div className="mb-6" data-id="element-416">
                    <label className="block text-sm font-medium mb-2" data-id="element-417">
                      NDA Requirement
                    </label>
                    <div className="flex items-center" data-id="element-418">
                      <input type="checkbox" id="nda" className="mr-2" data-id="element-419" />
                      <label htmlFor="nda" className="text-sm text-neutral-dark/80" data-id="element-420">
                        My inquiry requires an NDA before discussion
                      </label>
                    </div>
                  </div>
                  <Button variant="primary" size="lg" className="w-full" data-id="element-421">
                    Submit Inquiry
                  </Button>
                </form>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
      {/* FAQ Section */}
      <section className="py-16 bg-neutral-light/50" data-id="element-422">
        <div className="container mx-auto px-4 md:px-6" data-id="element-423">
          <div className="max-w-3xl mx-auto" data-id="element-424">
            <h2 className="text-3xl font-display font-bold mb-8 text-center" data-id="element-425">
              Frequently Asked Questions
            </h2>
            <div className="space-y-6" data-id="element-426">
              {[{
              question: 'What types of research projects do you handle?',
              answer: 'We conduct a wide range of research projects including consumer behavior studies, brand perception research, product testing, urban planning research, and more. Our methodologies include both qualitative and quantitative approaches tailored to your specific needs.'
            }, {
              question: 'How long does a typical research project take?',
              answer: "The timeline varies depending on the scope and complexity of the project. Small-scale projects may take 2-4 weeks, while more comprehensive studies can take 2-3 months. During our initial consultation, we'll provide a detailed timeline based on your specific requirements."
            }, {
              question: 'Do you work with clients outside of Toronto?',
              answer: "Yes, while we specialize in Toronto's multicultural market, we work with clients from across Canada and internationally who are interested in the Toronto market or who want to leverage our multicultural research expertise for their own diverse markets."
            }, {
              question: 'What makes your research methodology different?',
              answer: "Our approach combines rigorous research standards with specialized cultural knowledge. We employ multilingual researchers and cultural experts to ensure that our methodologies are culturally sensitive and that we capture authentic insights from Toronto's diverse communities."
            }].map((faq, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1,
              duration: 0.5
            }} className="bg-white p-6 rounded-lg shadow-md" data-id="element-427">
                  <h3 className="text-xl font-semibold mb-3" data-id="element-428">{faq.question}</h3>
                  <p className="text-neutral-dark/80" data-id="element-429">{faq.answer}</p>
                </motion.div>)}
            </div>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-16 bg-toronto-blue text-white" data-id="element-430">
        <div className="container mx-auto px-4 md:px-6" data-id="element-431">
          <div className="max-w-3xl mx-auto text-center" data-id="element-432">
            <h2 className="text-3xl font-display font-bold mb-6" data-id="element-433">
              Ready to Start Your Research Project?
            </h2>
            <p className="text-xl mb-8 opacity-90" data-id="element-434">
              Our team is ready to help you gain the insights you need to
              succeed in Toronto's diverse marketplace.
            </p>
            <div className="flex flex-wrap justify-center gap-4" data-id="element-435">
              <Button variant="secondary" size="lg" data-id="element-436">
                Schedule a Consultation
              </Button>
              <Button variant="outline" size="lg" className="border-white text-white hover:bg-white/10" data-id="element-437">
                View Our Services
              </Button>
            </div>
            <div className="flex items-center justify-center mt-8" data-id="element-438">
              <CheckCircleIcon size={20} className="text-canada-red mr-2" data-id="element-439" />
              <span className="text-white/90" data-id="element-440">
                Initial consultations are complimentary
              </span>
            </div>
          </div>
        </div>
      </section>
    </div>;
};
export default Contact;